import type { Job } from './refinery.ts';
import type { Item, Lot, Movement, People, PrepLevel, Ship, ShipStatus } from './schemas.ts';

// Supply's live topics (design §6.5, plan 2B Assumption 11).

/** Lots, prep levels, items and movements, for holders of supply.view: a StockChange. */
export const STOCK_TOPIC = 'supply.stock';

/** Ships and their readiness, for holders of supply.view. */
export const SHIPS_TOPIC = 'supply.ships';

/** Org refinery jobs, for holders of supply.refine. */
export const REFINERY_TOPIC = 'supply.refinery';

/** The personal topic's name, without its param. */
export const ME_TOPIC = 'supply.me';

/** One user's personal refinery jobs and the org jobs they refine; only that user may subscribe. */
export function meTopic(userId: string): string {
  return `${ME_TOPIC}:${userId}`;
}

/** Lots changed amount or details, with the movements that changed them. */
export interface LotsChange {
  type: 'lots';
  lots: Lot[];
  movements: Movement[];
  people: People;
}

/** A prep level was set or cleared. */
export interface PrepChange {
  type: 'prep';
  level: PrepLevel;
}

/** An item was created, edited or deactivated. */
export interface ItemChange {
  type: 'item';
  item: Item;
}

/** What supply.stock carries. */
export type StockChange = LotsChange | PrepChange | ItemChange;

/** A ship was created, edited, marked restocked or archived, with its status (null once archived). */
export interface ShipChange {
  type: 'ship';
  ship: Ship;
  status: ShipStatus | null;
  people: People;
}

/** A ship's readiness moved: a lot aboard or one of its prep levels changed. */
export interface StatusChange {
  type: 'status';
  status: ShipStatus;
}

/** What supply.ships carries. */
export type ShipsChange = ShipChange | StatusChange;

/** A refinery job was started, changed, picked up or cancelled: its whole view. On supply.refinery (org jobs) and the refiner's supply.me. */
export interface JobChange {
  type: 'job';
  job: Job;
  people: People;
}
